import React from "react";
import {Checkbox, Chip, Grid, Input, Stack, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import ReactLoading from "react-loading";

export const Loading = ({text, color, children, ...props}) =>
	<Stack direction={"column"} justifyContent={"center"} alignItems={"center"}>
		<ReactLoading type={"cylon"} color={"#fff"} height={50} width={50} {...props}/>
		{(text || children) && <Typography sx={{color: color || props.color || '#fff'}}>{text || children}</Typography>}
	</Stack>

export const LoadingText = props => <Loading text={"Loading..."} {...props}/>